import React from "react";
import { Link } from "react-router-dom";
import { IoLogoGithub } from "react-icons/io";
import { FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer">
      <footer className="bg-dark text-white pt-4">
        <div className="container">
          <div className="row">
            {/* About Me Section */}
            <div className="col-md-4">
              <h5>About Me</h5>
              <p>
                I am Akash Kumar Dubey, a passionate Full-Stack Web Developer
                dedicated to crafting seamless user experiences and scalable
                backend solutions. With a strong foundation in modern
                technologies and a creative mindset, I bring ideas to life with
                clean, efficient code. My goal? To transform concepts into
                reality while continuously learning and growing.
              </p>
            </div>
            {/* Quick Links Section */}
            <div className="col-md-4 my-2">
              <h5>Quick Links</h5>
              <ul className="list-unstyled">
                <li>
                  <Link
                    to="/project"
                    className="text-white text-decoration-none"
                  >
                    Projects
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-white text-decoration-none">
                    About Me
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-white text-decoration-none"
                  >
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-white text-decoration-none">
                    Blog
                  </Link>
                </li>
              </ul>
            </div>
            {/* Contact Info Section */}
            <div className="col-md-4">
              <h5>Contact Info</h5>
              <ul className="list-unstyled">
                <li>
                  <i className="bi bi-envelope" /> Email:
                  akashshaurya1998@gmail.com
                </li>
                <li>
                  <i className="bi bi-phone" /> Phone: +91 8009223090
                </li>
                <li>
                  <i className="bi bi-geo-alt" /> Location: Noida Uttar Pradesh,
                  India
                </li>
              </ul>
              {/* Social Media Icons */}
              <div className="mt-3">
                <Link
                  to="https://github.com/"
                  className="social-icon text-white me-3"
                  target="_blank"
                >
                  <IoLogoGithub />
                </Link>
                <Link
                  to="https://linkedin.com/"
                  className="social-icon text-white me-3"
                  target="_blank"
                >
                  <FaLinkedinIn />
                </Link>
                <Link
                  to="https://instagram.com/"
                  className="social-icon text-white me-3"
                  target="_blank"
                >
                  <FaInstagram />
                </Link>
              </div>
            </div>
          </div>
          {/* Footer Bottom */}
          <div className="text-center mt-4 border-top pt-3">
            <p className="mb-0">
              © 2024 Akash Kumar Dubey. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
